import React from 'react';
import Icon, { IconKey } from 'flow/components/ui-components/Icon';
import LabelPlate, { plateIconSize } from './LabelPlate';

interface StatusIconPlateProps {
    iconKey: IconKey;
    isCompact?: boolean;
    testId?: string;
}

/** A single status icon (muted mic, muted camera, caller) in a label plate. */
const StatusIconPlate: React.FC<StatusIconPlateProps> = ({
    iconKey,
    isCompact = false,
    testId,
}) => (
    <LabelPlate isCompact={isCompact} testId={testId} className="shrink-0">
        <Icon iconKey={iconKey} size={plateIconSize(isCompact)} />
    </LabelPlate>
);

export default StatusIconPlate;
